import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CheckOutDto } from '../../dtos/check-out.dto';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CheckOutDto,
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check
	if (!record) throw new Error('record is required.');

	// // Validate
	// const { error } = pricingItemSchema().validate(pricingItem, {
	// 	abortEarly,
	// });

	// // Check
	// if (error) {
	// 	return {
	// 		isValid: false,
	// 		errors: error.details?.map((e) => e.message),
	// 	};
	// }

	// Return
	return { isValid: true };
};
